// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f1773478","849":"262f1047"}[chunkId] + ".chunk.js";
};